import { useState } from "react";

import { useToast } from "./useToast";

export const useAPIToast = (apiRef, successHandleToast = _ => true) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const { addToast } = useToast();

  const onSend = async ({
    messageSuccess,
    messageFail,
    endpoint,
    type = "POST",
    data: dataFields = {},
    isDisableMsg = false,
  }) => {
    try {
      setIsLoading(true);
      const { data } = await apiRef({
        method: type,
        url: endpoint,
        data: dataFields,
      });

      if (!isDisableMsg && successHandleToast(data)) {
        addToast({
          type: "success",
          title: "SUCESSO",
          description: messageSuccess,
        });
        setData(data);
      }

      return data;
    } catch (err) {
      setData(err);
      if (!isDisableMsg) {
        addToast({
          type: "error",
          title: "FALHA",
          description: messageFail,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    data,
    onSend,
  };
};
